export default __webpack_public_path__ + "static/media/logo_02.ca0240ef.jpg";